module.exports = __webpack_public_path__ + "img/renew.4dbcf7e4.jpg";